import { FunctionComponent, useState } from "react";

import useSingleStudyDetail from "@src/modules/DicomViewer/ViewerStudyResults/hooks/useSingleStudyDetail";
import {
  CenterResultsWrapper,
  ViewerResultsHeader,
  ViewerResultsWrapper,
  ViewerStudyResultsPanel,
  ViewerStudyResultsWrapper,
  ViewerTilesWrapper,
} from "@src/modules/DicomViewer/ViewerStudyResults/ViewerStudyResults.components";
import { DateText } from "@src/modules/shared/components/components";
import { PanelTitle } from "@src/modules/shared/components/Panel/components";
import Results from "@src/modules/shared/components/Results/Results";
import CustomResults from "@src/modules/shared/components/Results/CustomResults";
import TestTile from "@src/modules/shared/components/TestTile";
import useStudyDateFormat from "@src/modules/shared/hooks/useStudyDateFormat";
import { StudyTestResult } from "@src/modules/shared/types";

interface Props {
  studyId: string;
}

const ViewerStudyResults: FunctionComponent<Props> = ({ studyId }) => {
  const [selectedTest, setSelectedTest] = useState<StudyTestResult>();

  const { data } = useSingleStudyDetail(studyId, {
    enabled: !!studyId,
    onSuccess: (data) => {
      const [firstTest] = data.tests;
      if (!selectedTest) setSelectedTest(firstTest);
    },
  });

  const formatDate = useStudyDateFormat();

  return (
    <ViewerStudyResultsPanel panelStyle="light">
      <PanelTitle>Test Results</PanelTitle>
      <ViewerStudyResultsWrapper>
        {data && (
          <ViewerTilesWrapper>
            <ViewerResultsHeader>{data.phantomName}</ViewerResultsHeader>
            {data.tests.map((test) => (
              <TestTile
                key={test.id}
                test={test}
                isActive={test.id === selectedTest?.id}
                onClick={() => {
                  setSelectedTest(test);
                }}
              />
            ))}
          </ViewerTilesWrapper>
        )}
        {data && selectedTest && (
          <CenterResultsWrapper>
            <ViewerResultsWrapper>
              <ViewerResultsHeader>{selectedTest.name}</ViewerResultsHeader>
              <DateText>
                {data.studyDate && formatDate(new Date(data.studyDate))}
              </DateText>
              {selectedTest.isCustomTest ? (
                <CustomResults
                  selectedStudyId={studyId}
                  selectedTest={selectedTest}
                  isEditingAvailable={data.canBeEditedOrDeleted}
                  hasImageRangeEditing={data.hasImagesRangeSelection}
                  imagesDisabled
                  hasDicoms={data.hasDicoms}
                />
              ) : (
                <Results
                  selectedStudyId={studyId}
                  selectedTest={selectedTest}
                  isEditingAvailable={data.canBeEditedOrDeleted}
                  hasImageRangeEditing={data.hasImagesRangeSelection}
                  imagesDisabled
                  hasDicoms={data.hasDicoms}
                />
              )}
            </ViewerResultsWrapper>
          </CenterResultsWrapper>
        )}
      </ViewerStudyResultsWrapper>
    </ViewerStudyResultsPanel>
  );
};

export default ViewerStudyResults;
